import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin: 0 auto;
  padding: 16px;

  @media screen and (min-width: 768px) {
    padding: 32px;
  }

  @media screen and (min-width: 1024px) {
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  div {
    width: 50%;

    h3 {
      font-size: 1.4em;
    }
  }
`;

export const StoreInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  span:nth-child(1) {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  @media screen and (min-width: 768px) {
  }

  @media screen and (min-width: 1024px) {
  }
`;
